export default function V2App() {
    return (
        <div className="v2-page" style={{ color: "var(--color-primary-v2)" }}>
            <h3>Welcome!</h3>
        </div>
    );
}
